var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "70%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.rules,
                    disabled: _vm.isAi ? true : _vm.disabled,
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "设备名称",
                                prop: "DeviceItemNameJson",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "calc(100% - 60px)" },
                                    attrs: {
                                      placeholder: "请选择设备",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.DeviceItemNameJson,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "DeviceItemNameJson",
                                          $$v
                                        )
                                      },
                                      expression: "form.DeviceItemNameJson",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "60px" },
                                      attrs: {
                                        type: "primary",
                                        disabled: _vm.dev.Id
                                          ? true
                                          : _vm.isAi
                                          ? true
                                          : _vm.disabled,
                                      },
                                      on: { click: _vm.openDevice },
                                    },
                                    [_c("i", { staticClass: "el-icon-search" })]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "故障类型", prop: "FaultType" } },
                            [
                              _c("SelectDicValue", {
                                ref: "SelectDicValue",
                                attrs: { code: "TheFaultType" },
                                model: {
                                  value: _vm.form.FaultType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "FaultType", $$v)
                                  },
                                  expression: "form.FaultType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "故障日期", prop: "FaultDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd HH:mm",
                                  format: "yyyy-MM-dd HH:mm",
                                  type: "datetime",
                                  placeholder: "请选择日期",
                                },
                                model: {
                                  value: _vm.form.FaultDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "FaultDate", $$v)
                                  },
                                  expression: "form.FaultDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "Describe",
                      attrs: { label: "故障图片", prop: "HeadImg" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          class: {
                            "disabled-upload": _vm.isAi ? true : _vm.disabled,
                          },
                          attrs: {
                            action:
                              _vm.$rootUrl +
                              `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`,
                            headers: {
                              Authorization: _vm.token,
                            },
                            "file-list": _vm.Imgs,
                            limit: 5,
                            "list-type": "picture-card",
                            "on-preview": _vm.handlePictureCardPreview,
                            "on-success": _vm.handleAvatarSuccess,
                            "on-remove": _vm.handleRemove,
                            "on-exceed": _vm.handleExceed,
                            "before-upload": _vm.beforeAvatarUpload,
                          },
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "故障描述", prop: "FaultDescription" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "",
                          type: "textarea",
                          rows: "6",
                          resize: "none",
                        },
                        model: {
                          value: _vm.form.FaultDescription,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "FaultDescription", $$v)
                          },
                          expression: "form.FaultDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isAi
                ? _c(
                    "el-form",
                    {
                      ref: "AIObj",
                      attrs: {
                        model: _vm.AIObj,
                        "label-width": "100px",
                        rules: _vm.AIObjrules,
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.title === "外委"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "供应商",
                                        prop: "Amount",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "calc(100% - 60px)",
                                        },
                                        attrs: {
                                          placeholder: "请选择供应商",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.AIObj.SupplierName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.AIObj,
                                              "SupplierName",
                                              $$v
                                            )
                                          },
                                          expression: "AIObj.SupplierName",
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "60px" },
                                          attrs: {
                                            type: "primary",
                                            disabled: _vm.disabled,
                                          },
                                          on: { click: _vm.openSup },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-search",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.title === "外委"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "合同编号",
                                        prop: "Contract",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          disabled: _vm.disabled,
                                          controls: false,
                                        },
                                        model: {
                                          value: _vm.AIObj.Contract,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.AIObj, "Contract", $$v)
                                          },
                                          expression: "AIObj.Contract",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.title === "外委"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "费用", prop: "Amount" },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          disabled: _vm.disabled,
                                          controls: false,
                                        },
                                        model: {
                                          value: _vm.AIObj.Amount,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.AIObj, "Amount", $$v)
                                          },
                                          expression: "AIObj.Amount",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "人员信息",
                                    prop: "OperatorIds",
                                  },
                                },
                                [
                                  _c("SelectData", {
                                    attrs: {
                                      multiple: "",
                                      url: "/Base_Manage/Base_User/GetDataList",
                                      option: {
                                        label: "RealName",
                                        Id: "Id",
                                      },
                                    },
                                    model: {
                                      value: _vm.AIObj.OperatorIds,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.AIObj, "OperatorIds", $$v)
                                      },
                                      expression: "AIObj.OperatorIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "工单日期",
                                    prop: "WorkOrderDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "请选择日期",
                                    },
                                    model: {
                                      value: _vm.AIObj.WorkOrderDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.AIObj,
                                          "WorkOrderDate",
                                          $$v
                                        )
                                      },
                                      expression: "AIObj.WorkOrderDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.title === "外委"
                            ? _c(
                                "el-col",
                                { attrs: { span: 16 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 2,
                                          placeholder: "请输入内容",
                                        },
                                        model: {
                                          value: _vm.form.Annotation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "Annotation",
                                              $$v
                                            )
                                          },
                                          expression: "form.Annotation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAi
                ? _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100px",
                            "text-align": "right",
                            "font-size": "14px",
                            padding: "0 12px 0 0",
                            color: "#606266",
                          },
                        },
                        [
                          _c("span", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(" 建议描述 "),
                        ]
                      ),
                      _c("quill-editor", {
                        ref: "myQuillEditor",
                        staticStyle: { height: "600px" },
                        attrs: { options: _vm.editorOption },
                        model: {
                          value: _vm.AIvalue,
                          callback: function ($$v) {
                            _vm.AIvalue = $$v
                          },
                          expression: "AIvalue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAi
                ? _c(
                    "el-row",
                    [
                      _c(
                        "div",
                        { staticStyle: { "line-height": "30px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addList },
                            },
                            [_vm._v("添加备件")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "MaterialsData",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.MaterialsData, height: "400px" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              width: "50",
                              type: "index",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "备件编号",
                              align: "center",
                              prop: "Code",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "备件名称",
                              align: "center",
                              prop: "Name",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "备件类型",
                              align: "center",
                              prop: "MaterialTypeName",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "备件规格",
                              align: "center",
                              prop: "Spec",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "单位",
                              align: "center",
                              prop: "storageName",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "货位",
                              align: "center",
                              prop: "LocalName",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "库存数量",
                              align: "right",
                              prop: "Nums_N",
                              sortable: "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "数量",
                              align: "center",
                              prop: "Num",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          controls: false,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.NumChange(
                                              $event,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.Num,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "Num", $$v)
                                          },
                                          expression: "scope.row.Num",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1676560423
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              prop: "op",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#f78989" },
                                          attrs: { type: "text", size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.MaterialsData.splice(
                                                scope.$index,
                                                1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4135523204
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              !_vm.disabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("DevDialog", {
        ref: "DevDialog",
        attrs: { type: "radio" },
        on: { select: _vm.handleDevSelect },
      }),
      _c("AIcopyDrawer", { ref: "AIcopyDrawer", on: { AI: _vm.AIchange } }),
      _c("FittingsOut", {
        ref: "FittingsOut",
        on: { select: _vm.selectFittingsOut },
      }),
      _c("Supplier", {
        ref: "Supplier",
        attrs: { type: "radio" },
        on: { select: _vm.selectSup },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }